import { useTranslation } from '../../hook/useTranslation';

interface IntelligenceRankLabelProps {
  rank?: number;
  label?: string;
}

export default function IntelligenceRankLabel({ rank, label }: IntelligenceRankLabelProps) {
  const { t } = useTranslation();
  let displayLabel = '';
  let style: React.CSSProperties = { backgroundColor: '#F5EEFE', color: '#9457F6' };

  // label prop이 제공된 경우 (새로운 방식)
  if (label) {
    displayLabel = t(label);
    if (label === 'report.summary.excellent' || label === '우수') {
      style = { backgroundColor: '#FEF8DE', color: '#F29723' };
    } else if (label === 'common.general' || label === '일반') {
      style = { backgroundColor: '#F5EEFE', color: '#9457F6' };
    } else if (label === 'report.summary.needs_improvement' || label === '보완') {
      style = { backgroundColor: '#FFEFF6', color: '#FF69AB' };
    } else {
      return null;
    }
  } else if (rank !== undefined) {
    // 기존 rank prop 방식 (하위 호환성)
    if (rank === 3) {
      displayLabel = t('report.summary.needs_improvement');
      style = { backgroundColor: '#FFEFF6', color: '#FF69AB' };
    } else if (rank === 2) {
      displayLabel = t('common.general');
      style = { backgroundColor: '#F5EEFE', color: '#9457F6' };
    } else if (rank === 1) {
      displayLabel = t('report.summary.excellent');
      style = { backgroundColor: '#FEF8DE', color: '#F29723' };
    } else {
      return null;
    }
  } else {
    return null;
  }

  return (
    <div
      className="h-[25px] w-auto bg-[#FEF8DE] text-[#F29723] rounded-xl text-[12px] font-[600] px-3 py-[2px] flex items-center justify-center whitespace-nowrap"
      style={style}
    >
      {displayLabel}
    </div>
  );
}
